export const fontsize = {
    fs10: '10px',
    fs14: '14px',
    fs16: '16px',
    fs25: '25px'
};
  